import { motion } from "framer-motion";
import { Reveal, Chapter } from "./Reveal";

const PICKER_IMG =
  "https://images.unsplash.com/photo-1521566652839-697aa473761a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwxfHxncm9jZXJ5JTIwc3RvcmUlMjBwaWNrZXIlMjB3b3JrZXJ8ZW58MHx8fHwxNzg2ODMwNTM2fDA&ixlib=rb-4.1.0&q=85";
const DRIVER_IMG =
  "https://images.unsplash.com/photo-1695653422259-8a74ffe90401?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwxfHxncm9jZXJ5JTIwZGVsaXZlcnklMjBkcml2ZXIlMjBydW5uZXJ8ZW58MHx8fHwxNzg2ODMwNTM2fDA&ixlib=rb-4.1.0&q=85";

const steps = [
  {
    n: "01",
    title: "The Pick",
    copy: "Dedicated in-store pickers hand-select every item the moment your order lands — no warehouse, no waiting.",
  },
  {
    n: "02",
    title: "The Sync",
    copy: "Pickers coordinate live with drivers, so your bag is handed off the second it's sealed. Zero idle time.",
  },
  {
    n: "03",
    title: "The Dash",
    copy: "Optimized routes carry your order straight to your door while it's still fresh off the shelf.",
  },
];

export const Teamwork = () => (
  <section
    id="sync"
    data-testid="teamwork-section"
    className="mx-auto max-w-[1400px] px-6 py-24 md:px-12 lg:py-36"
  >
    <div className="grid grid-cols-1 items-center gap-16 lg:grid-cols-12">
      <div className="relative lg:col-span-6">
        <Reveal>
          <div className="group relative w-[75%] overflow-hidden rounded-t-[10rem] rounded-b-3xl shadow-[0_40px_70px_-30px_rgba(4,47,30,0.3)]">
            <img
              src={PICKER_IMG}
              alt="Freshly picker selecting produce in-store"
              data-testid="teamwork-picker-image"
              className="h-[420px] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105 lg:h-[520px]"
            />
          </div>
        </Reveal>
        <Reveal delay={0.2} className="absolute -bottom-10 right-0 w-[52%]">
          <div className="group overflow-hidden rounded-3xl border-8 border-bone shadow-[0_30px_60px_-25px_rgba(4,47,30,0.35)]">
            <img
              src={DRIVER_IMG}
              alt="Freshly driver handing off a grocery bag"
              data-testid="teamwork-driver-image"
              className="h-[260px] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105 lg:h-[320px]"
            />
          </div>
        </Reveal>
      </div>

      <div className="lg:col-span-6 lg:pl-10">
        <Reveal>
          <Chapter number="01" label="The Sync" />
          <h2 className="mt-6 font-syne text-4xl font-extrabold leading-[1.02] tracking-tighter text-forest sm:text-5xl lg:text-6xl">
            Picked by hand.
            <br />
            <span className="text-fresh">Driven in sync.</span>
          </h2>
          <p className="mt-8 max-w-lg text-base leading-relaxed text-forest/70 md:text-lg">
            Our unique model pairs dedicated in-store pickers with real-time
            drivers. While your picker moves through the aisles, your driver is
            already en route — two roles, one clock, maximum speed.
          </p>
        </Reveal>
        <div className="mt-12 space-y-8">
          {steps.map((s, i) => (
            <Reveal key={s.n} delay={0.15 + i * 0.12}>
              <div className="group flex gap-6 border-t border-forest/10 pt-6">
                <span className="font-syne text-sm font-bold text-fresh">
                  {s.n}
                </span>
                <div>
                  <h3 className="font-syne text-xl font-bold text-forest transition-colors duration-300 group-hover:text-fresh">
                    {s.title}
                  </h3>
                  <p className="mt-2 max-w-md text-sm leading-relaxed text-forest/60">
                    {s.copy}
                  </p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
